import React from "react";
import Img from '../../Assets/hp8.png'
import { useNavigate } from 'react-router-dom';

const AboutUs6 = () => {

    const navigate = useNavigate();
    const handleNavigation = (to) => {
        console.log('handleNavigation called with path:', to);


        window.scrollTo(0, 0);
        navigate(to);

    };

    return (
        <div style={{
            backgroundImage: `url(${Img})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat'
        }} className="flex flex-col items-center justify-center text-white bg-black py-16 px-4 min-h-screen rounded-[30px] mb-[30px]">
            <h1 className="text-[49px] font-medium font-bricolage text-center mb-4 !font-['Bricolage_Grotesque']">
                Take Action Today for Safer Roads in America
            </h1>
            <p className="text-[28px] font-medium text-center max-w-2xl mb-8 !font-['Nunito']">
                If you or a loved one has been affected by an 18-wheeler accident, we are here to fight for your rights and justice.
            </p>
            {/* <div className="bg-[#ffc72c] text-[#1b1818] rounded-xl shadow-md px-8 py-2.5 font-bold text-lg !font-['Nunito']">
                Claim Form
            </div> */}
            <button
                onClick={() => handleNavigation('/claim')}
                className="block w-[50%] md:w-[12%] bg-yellow-400 text-gray-900 rounded-xl px-6 py-4 text-center shadow-md font-bold text-lg transition-all duration-300 border-none cursor-pointer"
                style={{
                    backgroundColor: "#ffc72c",
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <span className="relative z-10">Start Here</span>
                <span
                    className="absolute inset-0 bg-yellow-500 transform scale-x-0 origin-left transition-transform duration-300"
                    style={{
                        transformOrigin: 'left',
                        transition: 'transform 0.3s ease'
                    }}
                ></span>
            </button>
        </div>
    );
};

export default AboutUs6;
